"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Bell = function Bell(_ref) {
  var size = _ref.size,
      color = _ref.color,
      secondaryColor = _ref.secondaryColor;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "bell",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M4 .75c.28 0 .5.22.5.5v.56A2 2 0 016 3.75V5c0 .14.11.25.25.25s.25.11.25.25V6c0 .14-.11.25-.25.25h-1.5a.75.75 0 01-1.5.1v-.1h-1.5A.25.25 0 011.5 6v-.5c0-.14.11-.25.25-.25S2 5.14 2 5V3.75a2 2 0 011.5-1.94v-.56c0-.28.22-.5.5-.5zm0 2a1 1 0 00-1 .88v.62c0 .25-.02.5-.06.75l-.04.25h2.2c-.05-.25-.08-.5-.1-.75v-.75a1 1 0 00-1-1zM4 1a.25.25 0 100 .5.25.25 0 000-.5z"
  }), _react["default"].createElement("circle", {
    fill: secondaryColor,
    cx: "3.75",
    cy: "3.5",
    r: "1"
  }));
};

Bell.defaultProps = {
  size: 8,
  color: '#444',
  secondaryColor: '#444'
};
var _default = Bell;
exports["default"] = _default;